(function () {
  "use strict";

  // Prevent double binding
  if (window.__TT_PRODUCT_ACTIONS_BOUND__) return;
  window.__TT_PRODUCT_ACTIONS_BOUND__ = true;

  function guideTypeFromTags(tagsStr) {
    let tags = [];
    try {
      const parsed = JSON.parse(tagsStr);
      if (Array.isArray(parsed)) tags = parsed.map(String);
    } catch (e) {
      tags = String(tagsStr || "")
        .split("|")
        .map((t) => t.trim())
        .filter(Boolean);
    }

    const catTag = tags
      .map((t) => String(t).toLowerCase())
      .find((t) => t.startsWith("cat-"));
    if (!catTag) return "";

    const cat = catTag.replace("cat-", "").trim();

    // INTERNAL overlay type (keep "tees" here)
    if (cat === "tshirts" || cat === "t-shirts" || cat === "shirts") return "tees";
    if (cat === "polos") return "polos";
    if (cat === "sweats" || cat === "hoodies" || cat === "sweatshirts") return "sweats";
    if (cat === "hats" || cat === "beanies") return "hats";
    if (cat === "jackets" || cat === "outerwear") return "jackets";
    if (cat === "workshirts") return "workshirts";
    if (cat === "pants") return "pants";
    if (cat === "promos") return "promos";
    return "";
  }

  /**
   * Harden clicks inside TT modals so clicks don’t bubble and close overlays.
   * Safe: only binds once per element.
   */
  function hardenPlacementGuideClicks() {
    // Stop clicks inside dialog content from bubbling up to overlay/backdrop
    document.querySelectorAll(".tt-modal, .tt-mock-dialog").forEach((modal) => {
      if (modal.dataset.ttStopBound) return;
      modal.dataset.ttStopBound = "1";
      modal.addEventListener("click", (e) => e.stopPropagation());
    });

    // Backdrop click closes placement guide only when clicking the backdrop itself
    document.querySelectorAll(".tt-modal-overlay").forEach((overlay) => {
      if (overlay.dataset.ttOverlayBound) return;
      overlay.dataset.ttOverlayBound = "1";

      overlay.addEventListener("click", (e) => {
        if (e.target !== overlay) return;

        const type = overlay.getAttribute("data-tt-backdrop") || "";
        if (type && typeof window.TTclosePlacementGuide === "function") {
          window.TTclosePlacementGuide(type);
          return;
        }

        overlay.setAttribute("aria-hidden", "true");
        overlay.classList.remove("is-open");
        document.documentElement.classList.remove("tt-modal-open");
      });
    });
  }


    // -------- TT MOCKUP B1 (REMOVED: NEW-TAB MIGRATION) --------
  // The legacy modal Mockup (B1) button injection and all forced-open handlers
  // have been intentionally removed. Mockup is now handled by the new-tab preview page.
  // -----------------------------------------------------------

  function initProductActionbars() {
    document
      .querySelectorAll(".tt-actionbar--product[data-tt-product-tags]")
      .forEach((bar) => {
        const guideType = guideTypeFromTags(bar.getAttribute("data-tt-product-tags") || "");

        let client = "";
        try {
          client = (new URLSearchParams(window.location.search).get("client") || "").trim();
        } catch (e) {}

        const profileUrl = client ? `/collections/${client}` : "";

        // tees overlay -> tshirts collection handle
        const collectionSuffix = guideType === "tees" ? "tshirts" : guideType;
        const categoryUrl = client && collectionSuffix ? `/collections/${client}-${collectionSuffix}` : "";

        const btnBack = bar.querySelector("[data-tt-go-back]");
        const aHome = bar.querySelector("[data-tt-profile-home]");

        // Profile Homepage link
        if (aHome) {
          if (profileUrl) {
            aHome.href = profileUrl;
            aHome.classList.remove("tt-hide");
          } else {
            aHome.href = "#";
            aHome.classList.add("tt-hide");
          }
        }

        // Go Back (won’t go to Google on fresh tab)
        if (btnBack && !btnBack.dataset.ttBound) {
          btnBack.dataset.ttBound = "1";
          btnBack.addEventListener("click", () => {
  // === TT_GO_BACK_CLIENT_CATEGORY_ONLY ===
  // Always return to the shopping path (client > category/profile).
  // Never use history.back() to avoid mockup/back-stack loops.
  const fallback = categoryUrl || profileUrl || "/collections/all";
  window.location.href = fallback;
});

        }

        // NOTE: Mockup modal button injection intentionally removed (new-tab migration)
      });
  }

  // Make it available globally if needed
  window.initProductActionbars = initProductActionbars;

  function run() {
    try {
      initProductActionbars();
      hardenPlacementGuideClicks();
    } catch (e) {}
  }

  document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("pageshow", run);
  run();
})();
